import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  card: {
    background: theme.palette.background.paper,
    borderRadius: 16,
    padding: '20px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    textAlign: 'center'
  },
  title: {
    fontWeight: 700,
    fontSize: '0.95rem',
    color: theme.palette.secondary.dark,
    marginBottom: 4,
    textAlign: 'center'
  },
  line: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.primary,
    textAlign: 'center'
  }
}))
